// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-tooltip__popper.tooltip-item {\n  max-width: 800px;\n}\n.el-tooltip__popper.tooltip-item div {\n    max-height: 68px;\n    overflow: hidden;\n    overflow-y: scroll;\n    scrollbar-width: none;\n}\n.more-flag-box .content p {\n  font-weight: 400;\n  color: #666666;\n  line-height: 20px;\n  margin-bottom: 8px;\n}\n.more-flag-box .content p:nth-last-of-type(1) {\n    margin-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
